module.exports = __webpack_public_path__ + "img/scsvg.7593a224.svg";